import React from 'react';
import './Careers.css';

const Careers = () => {
    const jobOpenings = [
        {
            title: 'Business Development Executive',
            department: 'Business Development',
            location: 'Amravati, India',
            type: 'Full-time',
            description: 'We are seeking an experienced Business Development Executive to join our team.'
        }
        // {
        //     title: 'Quality Control Analyst',
        //     department: 'Quality Control',
        //     location: 'Mumbai, India',
        //     type: 'Full-time',
        //     description: 'Looking for a detail-oriented Quality Control Analyst to ensure our products meet the highest quality standards.'
        // },
        // {
        //     title: 'Production Supervisor',
        //     department: 'Manufacturing',
        //     location: 'Mumbai, India',
        //     type: 'Full-time',
        //     description: 'Seeking an experienced Production Supervisor to oversee manufacturing operations and ensure efficient production processes.'
        // }
    ];

    return (
        <div className="careers-section">
            <div className="careers-header">
                <h1>Join Our Team</h1>
                <p>Be part of our mission to improve global healthcare through innovation and excellence</p>
            </div>

            <div className="why-join-us">
                <h2>Why Join D-Astars?</h2>
                <div className="benefits-grid">
                    <div className="benefit-card">
                        <i className="fas fa-flask"></i>
                        <h3>Innovation</h3>
                        <p>Work with cutting-edge technology and contribute to groundbreaking research</p>
                    </div>
                    <div className="benefit-card">
                        <i className="fas fa-users"></i>
                        <h3>Great Culture</h3>
                        <p>Join a collaborative team that values creativity and personal growth</p>
                    </div>
                    <div className="benefit-card">
                        <i className="fas fa-chart-line"></i>
                        <h3>Growth</h3>
                        <p>Opportunities for career advancement and professional development</p>
                    </div>
                    <div className="benefit-card">
                        <i className="fas fa-heart"></i>
                        <h3>Benefits</h3>
                        <p>Competitive salary, health insurance, and work-life balance</p>
                    </div>
                </div>
            </div>

            <div className="current-openings">
                <h2>Current Openings</h2>
                <div className="job-listings">
                    {jobOpenings.map((job, index) => (
                        <div key={index} className="job-card">
                            <h3>{job.title}</h3>
                            <div className="job-details">
                                <span><i className="fas fa-building"></i> {job.department}</span>
                                <span><i className="fas fa-map-marker-alt"></i> {job.location}</span>
                                <span><i className="fas fa-clock"></i> {job.type}</span>
                            </div>
                            <p>{job.description}</p>
                            <button className="apply-button">Apply Now</button>
                        </div>
                    ))}
                </div>
            </div>

            <div className="application-process">
                <h2>Application Process</h2>
                <div className="process-steps">
                    <div className="step">
                        <div className="step-number">1</div>
                        <h3>Apply Online</h3>
                        <p>Submit your application through our career portal</p>
                    </div>
                    <div className="step">
                        <div className="step-number">2</div>
                        <h3>Initial Review</h3>
                        <p>Our HR team will review your application</p>
                    </div>
                    <div className="step">
                        <div className="step-number">3</div>
                        <h3>Interviews</h3>
                        <p>Technical and cultural fit interviews</p>
                    </div>
                    <div className="step">
                        <div className="step-number">4</div>
                        <h3>Offer</h3>
                        <p>Successful candidates receive job offers</p>
                    </div>
                </div>
            </div>

            <div className="contact-hr">
                <h2>Questions?</h2>
                <p>Contact our HR team at <a href="mailto:dastarstrade13@gmail.com">dastarstrade13@gmail.com</a></p>
            </div>
        </div>
    );
};

export default Careers;
